<template>
  <div class="">
    <Sliders></Sliders>
    <LatestProjects></LatestProjects>
    <!-- <thumbnails></thumbnails> -->
    <GeneralDonation></GeneralDonation>
    <TotalCount></TotalCount>
    <LatestNews></LatestNews>
    <WhoWeAre></WhoWeAre>
  </div>
</template>

<script>
export default {
  name: "List",
  components: {
    Sliders: () => import("@/components/Sliders.vue"),
    // Thumbnails: () => import("@/components/Thumbnails.vue"),
    WhoWeAre: () => import("@/components/WhoWeAre.vue"),
    GeneralDonation: () => import("@/components/GeneralDonation.vue"),
    LatestProjects: () => import("@/components/LatestProjects.vue"),
    TotalCount: () => import("@/components/TotalCount.vue"),
    LatestNews: () => import("@/components/LatestNews.vue"),
  },
  data() {
    return {
      //
    };
  },
  mounted() { },
  created() {
    //
  },
  methods: {
    //
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
